import { render, staticRenderFns } from "./manage-cookie-modal.vue?vue&type=template&id=3c6d4c26"
import script from "./manage-cookie-modal.vue?vue&type=script&lang=js"
export * from "./manage-cookie-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports